import { BASE_URL } from '../../../../../utils/config.base-url'

export const URL_ENDPOINT_XE = `${BASE_URL}/xe`
export const XE_PREFIX_URL = '/xe'
